import { render } from "./UserAccount.vue?vue&type=template&id=bd82c9cc"
import script from "./UserAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccount.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/UserAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd82c9cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd82c9cc', __exports__)) {
    api.reload('bd82c9cc', __exports__)
  }
  
  module.hot.accept("./UserAccount.vue?vue&type=template&id=bd82c9cc", () => {
    api.rerender('bd82c9cc', render)
  })

}


export default __exports__